module.exports = __webpack_public_path__ + "img/fb-preview.8c0fb064.png";